var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"function-list"},[_c('p',{staticClass:"tip-block"},[_c('Icon',{attrs:{"type":"md-alert"}}),_vm._v(" "+_vm._s(_vm.$t('services.funcTip'))+" ")],1),_c('Table',{attrs:{"columns":_vm.recordsCol,"data":_vm.tableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }